import $, { data } from 'jquery';
// import './qrcode2.js'
import'../page/jquery.cookie.js'
import QRCode from 'qrcodejs2';

export default {
    mounted(){
    console.log("我是我");
    
var _api = 'https://scm-member-api.expopaas.com'
var user_token = $.cookie('company_user_token')
var company_info = {
    status: '0',
}

var qrcode = new QRCode(document.getElementById('pay-img'),{
    width: 137,
    height: 137,
    correctLevel: QRCode.CorrectLevel.M
});
$('#j-xf').hide()
$('.istab1').show()
$('.istab2').hide()
get_company()

// 页面初始化
function set_company_status() {
    if(company_info.member&&(company_info.member.orderCount>1||company_info.member.extendClick)){
        $('#sqjr').html('VIP会员续费')
        $('.istab1').hide()
        $('.istab2').show()
        $('#box-status-4').show().siblings().hide();
        $('.noSq').hide()
        $('.yesSq').show()
        if(company_info.member.extendClick){
            $('.xfTime1').show()
            $('.xfTime2').hide()
            $('.tab-status-5').addClass('active').siblings().removeClass('active')
            $('.xfAlign').hide()
            $('.pay_status_all_0').show()
            $('.pay_status_all_1').hide()
        }else{
            $('.xfTime1').hide()
            $('.xfTime2').show()
            $('.tab-status-6').addClass('active').siblings().removeClass('active')
            $('.xfAlign').show()
            $('.pay_status_all_0').hide()
            $('.pay_status_all_1').show()
            // 发票状态
            get_invoice()
        }
        if(company_info.member.endDay<=90){
            $('#j-xf').show()
            if (company_info.member.endDay == 0) {
                $('#xf-msg').html('您的会员已到期')
            }else{
                $('#xf-msg').html('您的会员还有'+company_info.member.endDay+'日即将到期')
            }
            
        }else{
            $('#j-xf').hide()
        }
    }else{
        $('.istab1').show()
        $('.istab2').hide()
        $('.xfTime1').show()
        $('.xfTime2').hide()
       if (company_info.status == '1') { // 提交企业信息
            $('#j-xf').hide()
            $('.tab-status-0').addClass('active').siblings().removeClass('active')
            $('#box-status-0').show().siblings().hide();
        } else if (company_info.status == '2') { // 企业信息审核
            $('#j-xf').hide()
            $('.tab-status-1').addClass('active').siblings().removeClass('active')
            $('#box-status-1').show().siblings().hide();
            // $('.company').html(company_info.company)
            // $('.pay_tax').html(company_info.pay_tax)

            if (company_info.company.status == 2) {
                $('#j-status-1').hide()
                $('#j-status-2').show()
            } else { // 驳回
                $('#j-status-1').show()
                $('#j-status-2').hide() 
            }

        } else if (company_info.status == '3') { // 选择入住方式
            $('#j-xf').hide()
            $('.tab-status-2').addClass('active').siblings().removeClass('active')
            $('#box-status-2').show().siblings().hide();
        } else if (company_info.status == '4') { // 入驻审核
            $('#j-xf').hide()
            $('.tab-status-3').addClass('active').siblings().removeClass('active')
            $('#box-status-3').show().siblings().hide();

            $('#j-status-4').show()
            $('#j-status-5').hide()

            // if (company_info.status == '4') {
            //     $('#j-status-4').show()
            //     $('#j-status-5').hide()
            // } else { // 驳回
            //     $('#j-status-4').hide()
            //     $('#j-status-5').show()
            // }
            

        } else if (company_info.status == '5') { // 入驻成功
            $('.tab-status-4').addClass('active').siblings().removeClass('active')
            $('#box-status-4').show().siblings().hide();
            if(company_info.member.endDay<=90){
                $('#j-xf').show()
                if (company_info.member.endDay == 0) {
                    $('#xf-msg').html('您的会员已到期')
                }else{
                    $('#xf-msg').html('您的会员还有'+company_info.member.endDay+'日即将到期')
                }
                
            }else{
                $('#j-xf').hide()
            }
            
            // 发票状态
            get_invoice()
    
            // 续费
            // if(company_info.status == '7'){
            //     var time = new Date()
            //     var end_time = new Date(company_info.end_time)
            //     var end_time2 = (end_time.getTime() - time.getTime())/86400000
            //     // console.log(end_time2)
            //     $('#j-xf').show()
            //     $('#xf-msg').html('您的会员已到期')
            //     if(end_time2 >= 1){
            //         $('#xf-msg').html('您的会员还有'+parseInt(end_time2)+'日即将到期')
            //     }
                
            // }
        } 
    }
    

    $('.bhyy').text('驳回原因：' + company_info.company.rejectReason)
    // 查看合同
    $('.j-ht-up-sub').hide()
    if(company_info.contract_url){
        // $('.j-ht').prop('href', company_info.contract_url).show()
        $('.j-ht').show()
        $('.j-ht-up').hide()
    }else{
        $('.j-ht').hide()
        $('.j-ht-up').show()
        
    }

    // 时间
    $('.create_time').html(company_info.member.startTime)
    $('.end_time').html(company_info.member.endTime)


    // 付款状态
    $('.pay_status').hide()
    // 方式2 无需保证金
    if(company_info.company.status == '1'){
        $('.sqrz-type-2-x').show()
        $('.sqrz-type-1-x').hide()

        $('.sqrz-type-2').show()
        $('.sqrz-type-1').hide()

        if(company_info.member.isVip == '1'){
            $('.pay_status_all_1').show()
            
        }else{
            $('.pay_status_all_0').show()
        }
    }
    if(company_info.member.isVip == '1'){
        if(company_info.member.extendClick){
            $('.pay_status_all_0').show()
            $('.pay_status_all_1').hide()
        }else{
            $('.pay_status_all_0').hide()
            $('.pay_status_all_1').show()
        }
    }
    // else{ // 方式1
    //     $('.sqrz-type-1-x').show()
    //     $('.sqrz-type-2-x').hide()

    //     $('.sqrz-type-1').show()
    //     $('.sqrz-type-2').hide()

    //     if(company_info.pay_status == '1' && company_info.margin_status == '1'){
    //         $('.pay_status_all_1').show()
            
    //     }else{
    //         if(company_info.pay_status == '1'){
    //             $('.pay1_margin0').show()
    //         }else if(company_info.margin_status == '1'){
    //             $('.pay0_margin1').show()
    //         }else{
    //             $('.pay_status_all_0').show()
    //         }
    //     }
    // }

    $('.company').html(company_info.company.companyName)
    $('.pay_tax').html(company_info.company.taxCode)
    $('.input-company').val(company_info.company.companyName)
    $('.input-pay_tax').val(company_info.company.taxCode)

    $('.design_phone').html(company_info.member.designMobilePhone)
    $('.per_phone').html(company_info.per_phone)
    $('.bc_name').html(company_info.member.projectAccount)

    $('.pay_price').html('¥'+company_info.payInfo.price)
    $('.margin_free').html('¥'+company_info.margin_free)
    $('.margin_free_pay_price').html('¥'+(Number(company_info.pay_price) + Number(company_info.margin_free)).toFixed(2) )

    if(company_info.pay_type){
        pay_type = company_info.pay_type == '0'? '1': company_info.pay_type
    }else{
        pay_type = '1'
    }
    
    // change_pay_type()
    // $('#j-pay-dialog').fadeIn()
    
}
// 重新申请
$('#j-cxsq').on('click', function () {              
    company_info.status = '1'
    set_company_status()
})
// 重新入驻
$('#j-cxrz').on('click', function () {
    company_info.status = '3'
    set_company_status()
})

// 获取入住信息
function get_company() {
    if (!user_token) {
        return false
    }
    $.ajax({
        type: "get",
        url: _api+"/web/v1/user/info/getStep",
        headers: {Authorization: user_token},
        dataType: "json",
        success: function (res) {
            if (res.code == 0) {
                console.log("11111",res.data);
                
                // company_info = res.data
                // company_info.status = '7' // 调试 "status": "状态 1待审核 2审核驳回 3审核通过未入驻 4入驻待审核 5入驻驳回 6已入驻 7已结束",
                // company_info.type = '2' // 入驻方式
                // company_info.invoice = '1' // 调试 发票未申请
                // company_info.pay_status = '0' // 调试 
                // company_info.pay_type = '0' // 调试 
                // company_info.contract_url = ''
                // set_company_status()
                getInfoPersion(res.data.step)

            }
        }
    });
}
function getInfoPersion(status){
    if (!user_token) {
        return false
    }
    $.ajax({
        type: "get",
        url: _api+"/web/v1/user/info/getInfo",
        headers: {Authorization: user_token},
        dataType: "json",
        success: function (res) {
            if (res.code == 0) {
                console.log("2222222",res.data);
                company_info = res.data
                company_info.status = status
                
                // company_info.status = '7' // 调试 "status": "状态 1待审核 2审核驳回 3审核通过未入驻 4入驻待审核 5入驻驳回 6已入驻 7已结束",
                // company_info.type = '2' // 入驻方式
                // company_info.invoice = '1' // 调试 发票未申请
                // company_info.pay_status = '0' // 调试 
                // company_info.pay_type = '0' // 调试 
                // company_info.contract_url = ''
                set_company_status()

            }
        }
    });
}
// 提交企业信息
var sub_qyxx_data = {
    // user_token: user_token,     //{{user_type}}
    company: '',        //企业名称
    pay_tax: '',        //纳税号
    license_url: '',    //营业执照
    credit_url: ''      //资信文件
}

// 营业执照
$('#j-btn-yyzz').on('click', function () {
    if (user_token == null) {
        toast({ msg: '请先登录' })
        $('#j-login-dialog').fadeIn()
        return
    }
    $('#file-yyzz').click()
})
$('#file-yyzz').on('change', function (e) {
    var _file = this.files[0]
    console.log(" _file", _file);
    var maxFileSize = 1024*1024*2;
    if( _file.size>maxFileSize){
        toast({ msg: '文件大小不能超过2M' })
        return
    }
    $('#file-name-yyzz').html(_file.name)
    var fd = new FormData()
    fd.append('file', _file)
    $.ajax({
        type: "POST",
        url: _api+"/web/v1/external/cos/uploadFile",
        headers: {Authorization: user_token},
        data: fd,
        cache: false,
        contentType: false,// 数据不需要编码
        processData: false,// 数据对象不需要转换成键值对格式
        dataType: "json",
        success: function (res) {
            if (res.code == 0) {
                sub_qyxx_data.license_url = res.data.url
            }else{
                toast({ msg: res.msg })
            }
        }
    })
})

// 资信文件
$('#j-btn-zxwj').on('click', function () {
    if (user_token == null) {
        toast({ msg: '请先登录' })
        $('#j-login-dialog').fadeIn()
        return
    }
    $('#file-zxwj').click()
})
$('#file-zxwj').on('change', function (e) {
    var _file = this.files[0]
    var maxFileSize = 1024*1024*2;
    if( _file.size>maxFileSize){
        toast({ msg: '文件大小不能超过2M' })
        return
    }
    $('#file-name-zxwj').html(_file.name)

    var fd = new FormData()
    fd.append('file', _file)
    $.ajax({
        type: "POST",
        url: _api+"/web/v1/external/cos/uploadFile",
        headers: {Authorization: user_token},
        data: fd,// JSON.stringify({file: e.target.result}),
        cache: false,
        contentType: false,// 数据不需要编码
        processData: false,// 数据对象不需要转换成键值对格式
        dataType: "json",
        success: function (res) {
            if (res.code == 0) {
                sub_qyxx_data.credit_url = res.data.url
            }else{
                toast({ msg: res.msg })
            }
        }
    })
})
$('#qyxx-company,#qyxx-pay_tax').on('click',function(){
    if (user_token == null) {
        toast({ msg: '请先登录' })
        $('#j-login-dialog').fadeIn()
        return
    }
})

// 提交企业信息
$('#sub-qyxx').on('click', function () {
    sub_qyxx_data.company = $('#qyxx-company').val()
    sub_qyxx_data.pay_tax = $('#qyxx-pay_tax').val()

    if (user_token == null) {
        toast({ msg: '请先登录' })
        $('#j-login-dialog').fadeIn()
        return
    }
    // if(!sub_qyxx_data.company ||
    //     !sub_qyxx_data.pay_tax ||
    //     !sub_qyxx_data.license_url 
    //     ){
    //     toast({ msg: '请填写完整信息' })
    //     return
    // }
    sub_qyxx()
})
function sub_qyxx() {
    // var sub_qyxx_data = {
    //     // user_token: user_token,     //{{user_type}}
    //     company: '',        //企业名称
    //     pay_tax: '',        //纳税号
    //     license_url: '',    //营业执照
    //     credit_url: ''      //资信文件
    // }
    sub_qyxx_data.companyName = sub_qyxx_data.company
    sub_qyxx_data.taxCode = sub_qyxx_data.pay_tax
    sub_qyxx_data.businessLicense = sub_qyxx_data.license_url
    sub_qyxx_data.file = sub_qyxx_data.credit_url
    $.ajax({
        type: "POST",
        url: _api+"/web/v1/user/company/apply",
        headers: {Authorization: user_token},
        data: sub_qyxx_data,
        dataType: "json",
        success: function (res) {
            if (res.code == 0) {
                // $('#j-register-dialog').fadeOut()
                get_company()
            }else{
                toast({ msg: res.msg })
            }
        }
    });
}
// 申请入驻
var sub_sqrz_data = {
    // user_token: user_token,
    type: "2",                       // 1：方式一2：方式二'
    contract_url: {},               // data:application/pdf;base64,JVBERi0xLjQKJdPr6eEKM... 回传合同：方式一为：必选
    design_phone: '',               //设计云手机号
    design_verification_code: '',   // 设计云验证码
    design_password: '',            // 设计云密码
    per_phone: '',                  // 主场云手机号：方式二为：必选
    per_verification_code: '',      //主场云验证码：方式二为：必选
    bc_name: '',                    // 展装云账号名：方式二为：必选
    bc_password: '',                 // 展装密码：方式二为：必选
}
var ht_list = [];
change_sqrz_type()
function change_sqrz_type() {
    if (sub_sqrz_data.type == '2') {
        console.log("我是2");
        
        $('.sqrz-type-2').show()
        $('.sqrz-type-1').hide()

        ht_list = []
        set_ht_list(ht_list, '#ht-list')
        sub_sqrz_data.contract_url = {}
        $('#ht-name').html('')
    } else if (sub_sqrz_data.type == '1') {
        console.log("我是1");
        $('.sqrz-type-1').show()
        $('.sqrz-type-2').hide()

        sub_sqrz_data.per_phone = ''
        sub_sqrz_data.per_verification_code = ''
        sub_sqrz_data.bc_name = ''
        sub_sqrz_data.bc_password = ''

        $('#per_phone').val('')
        $('#per_verification_code').val('')
        $('#bc_name').val('')
        $('#bc_password').val('')
    }
}
// 选择入住方式
$('.sqrz-type').on('click', function () {
    var _this = $(this)
    $('.sqrz-type').removeClass('checked')
    _this.addClass('checked')

    sub_sqrz_data.type = _this.attr('value')
    console.log("sub_sqrz_data.type",sub_sqrz_data.type);
    
    change_sqrz_type()
})
// 入驻 回传合同
$('#ht-btn').on('click', function () {
    $('#ht-file').click()
})
$('#ht-file').on('change', function (e) {
    var _file = this.files[0]
    // $('#ht-name').html(_file.name)
    var fd = new FormData()
    fd.append('file', _file)
    $.ajax({
        type: "POST",
        url: _api+"/company_order/upload_file",
        headers: {Authorization: user_token},
        data: fd,
        cache: false,
        contentType: false,// 数据不需要编码
        processData: false,// 数据对象不需要转换成键值对格式
        dataType: "json",
        success: function (res) {
            if (res.code == 0) {
                // sub_qyxx_data.license_url = e.target.result
                ht_list.push({
                    name: _file.name,
                    result: res.data // e.target.result
                })
                set_ht_list(ht_list, '#ht-list')
            }else{
                toast({ msg: res.msg })
            }
        }
    })
    // var reader = new FileReader();
    // reader.readAsDataURL(_file);
    // reader.onload = function (e) {
    //     ht_list.push({
    //         name: _file.name,
    //         result: e.target.result
    //     })
    //     set_ht_list(ht_list, '#ht-list')
    // };
})
function set_ht_list(list, id){
    var html = ''
    for(var i=0, j=list.length; i<j; i++){
        html += '<li><span>'+list[i].name+'</span><i class="del" data-index="'+i+'"></i></li>'
    }
    $(id).html(html)
}
$('#ht-list').on('click','.del',function(){
    var index = $(this).attr('data-index')
    ht_list.splice(index,1)
    set_ht_list(ht_list, '#ht-list')
})
function set_contract_url(list){
    var data = {}
    for(var i=0, j=list.length; i<j; i++){
        data[i+1] = list[i].result
    }
    return data //JSON.stringify(data)
}

// 设计云验证码
_get_code('#btn-design_verification_code', '#design_phone', '/web/v1/auth/sendSms')
// 主场验证码
_get_code('#btn-per_verification_code', '#per_phone', '/company_order/per_verification_code')


// 提交入驻
$('#sub-sqrz').on('click', function () {
    sub_sqrz_data.design_phone = $('#design_phone').val()
    sub_sqrz_data.design_verification_code = $('#design_verification_code').val()
    sub_sqrz_data.design_password = $('#design_password').val()
    console.log("无数1",sub_sqrz_data);
    if (sub_sqrz_data.type == '2') {
        console.log("无数2");
        
        // sub_sqrz_data.per_phone = $('#per_phone').val()
        // sub_sqrz_data.per_verification_code = $('#per_verification_code').val()
        sub_sqrz_data.bc_name = $('#bc_name').val()
        sub_sqrz_data.bc_password = $('#bc_password').val()

        if (!sub_sqrz_data.design_phone ||
            !sub_sqrz_data.design_verification_code ||
            !sub_sqrz_data.design_password ||
            !sub_sqrz_data.bc_name ||
            !sub_sqrz_data.bc_password) {
            toast({ msg: '请填写完整信息' })
            return false
        }
        if(!check_phone(sub_sqrz_data.design_phone)){
            toast({ msg: '设计云：手机格式不正确' })
            return false
        }
        // if(!check_phone(sub_sqrz_data.per_phone)){
        //     toast({ msg: '主场云：手机格式不正确' })
        //     return false
        // }

        
    // if (sub_sqrz_data.type == '2') {
        if ($('#j-xieyi').hasClass('checked')) {
            console.log("点击了11111");
            
        } else {
            toast({ msg: '请阅读并同意《会展供应链平台VIP入驻商协议》' })
            return false
        }
    } else {
        if (!sub_sqrz_data.design_phone ||
            !sub_sqrz_data.design_verification_code ||
            !sub_sqrz_data.design_password ||
            !ht_list.length) {
            toast({ msg: '请填写完整信息' })
            return false
        }
        if(!check_phone(sub_sqrz_data.design_phone)){
            toast({ msg: '设计云：手机格式不正确' })
            return false
        }
        sub_sqrz_data.contract_url = set_contract_url(ht_list)
    }
    // console.log(sub_sqrz_data)
    sub_sqrz()
})
function sub_sqrz() {
    console.log("我是提交",sub_sqrz_data);
    sub_sqrz_data.designMobilePhone = sub_sqrz_data.design_phone
    sub_sqrz_data.code = sub_sqrz_data.design_verification_code
    sub_sqrz_data.designPassword = sub_sqrz_data.design_password
    sub_sqrz_data.projectAccount = sub_sqrz_data.bc_name
    sub_sqrz_data.projectPassword = sub_sqrz_data.bc_password
    $.ajax({
        type: "POST",
        url: _api+"/web/v1/user/member/add",
        headers: {Authorization: user_token},
        data: sub_sqrz_data,
        dataType: "json",
        success: function (res) {
            if (res.code == 0) {
                get_company()
                // 付款
                change_pay_type()
                $('#j-pay-dialog').fadeIn()
            }else{
                toast({ msg: res.msg })
            }
        }
    });
}
// 付款
var pay_type = '1'
$('.btn-pay').on('click',function(){
    $('#j-pay-dialog').fadeIn()
    change_pay_type()
    if(company_info.member&&(company_info.member.orderCount>1||company_info.member.extendClick)){
        $('.isvipxf').html('VIP会员续费')
    }
})
// 选择付款方式
$('.pay-type').on('click', function () {
    
    // if(company_info.pay_type != '0'){
    //     toast({ msg: '订单已选择付款方式！无法修改' })
    //     return false
    // }
    
    
    var _this = $(this)
    // $('.pay-type').removeClass('checked')
    // _this.addClass('checked')
    var val = _this.attr('value')
    console.log("123",val);
    if(val == 2){
        $('.bank').html(company_info.payInfo.bank)
        $('.company1').html(company_info.payInfo.company)
        $('.account').html(company_info.payInfo.account)
    }
    if(val != pay_type){
        pay_type = val
        change_pay_type()
    }
})
function change_pay_type(){
    $('.pay-type').removeClass('checked')
    $('.pay-type[value='+pay_type+']').addClass('checked')
    if(timeout_get_pay_status){
        clearTimeout(timeout_get_pay_status)
    }
    if(pay_type == '1'){
        $('.pay-type-1').show()
        $('.pay-type-2').hide()
        get_pay_url()
    }else{
        $('.pay-type-1').hide()
        $('.pay-type-2').show()
        
    }
}

// 线下付款
$('#btn-pay-sub').on('click', function(){
    $.ajax({
        type: "POST",
        url: _api+"/web/v1/order/info/memberOfflinePay",
        headers: {Authorization: user_token},
        dataType: "json",
        success: function (res) {
            
            if (res.code == 0) {
                $('#j-pay-dialog').fadeOut()
                get_company()
            }else{
                toast({ msg: res.msg })
                $('#j-pay-dialog').fadeOut()
            }
        }
    });
})

// 获取支付码链接
function get_pay_url(){
    // qrcode.clear();
    $.ajax({
        type: "GET",
        url: _api+"/web/v1/pay/wechat/getMemberPayQrcode",
        headers: {Authorization: user_token},
        dataType: "json",
        success: function (res) {
            // toast({ msg: res.msg })
            if (res.code == 0) {
                
                setTimeout(() => {
                    qrcode.makeCode(res.data.qrcode);
                }, 0);
                
                // $('#pay-img').attr('src', _api+'/company_order/get_qrcode_img?url='+res.data+'&user_token='+user_token)
                get_pay_status(res.data.outTradeNo)
            }else{
                toast({ msg: res.msg })
            }
        }
    });
}

// 获取支付状态
var timeout_get_pay_status = null
function get_pay_status(outTradeNo){
    $.ajax({
        type: "get",
        url: _api+"/web/v1/order/info/getPayStatus",
        headers: {Authorization: user_token},
        dataType: "json",
        data: {outTradeNo:outTradeNo},
        success: function (res) {
            // toast({ msg: res.msg })
            if (res.code == 0) {
                if(res.data.status){
                  toast({ msg: '支付成功' })
                    $('#j-pay-dialog').fadeOut()
                    get_company()  
                }else{
                    console.log("99999999");
                    
                    timeout_get_pay_status = setTimeout(()=>{
                        get_pay_status(outTradeNo)
                    }, 2000)
                }
                
            }else{
                // timeout_get_pay_status = setTimeout(get_pay_status(outTradeNo), 3000)
                    toast({ msg: res.msg })
            }
        }
    });
}

// 查看合同
$('.j-ht').on('click',function(){
    // company_info.contract_url
    var list = JSON.parse(company_info.contract_url)
    var html = ''
    for(var key in list){
        html += '<li><a href="'+_api+'/company/show-image?imageName='+list[key]+'" target="_blank">'+list[key]+'</a></li>'
    }
    $('#look-ht-list').html(html)
    $('#j-ht-dialog').fadeIn()
})
// 审核阶段 上传合同
var ht_list2 = []
$('.j-ht-up').on('click',function(){
    $('#ht-file-2').click()
})
$('#ht-file-2').on('change', function (e) {
    var _file = this.files[0]

    // $('#ht-name').html(_file.name)
    var fd = new FormData()
    fd.append('file', _file)
    $.ajax({
        type: "POST",
        url: _api+"/company_order/upload",
        headers: {Authorization: user_token},
        data: fd,
        cache: false,
        contentType: false,// 数据不需要编码
        processData: false,// 数据对象不需要转换成键值对格式
        dataType: "json",
        success: function (res) {
            // toast({ msg: res.msg })
            if (res.status == 200) {
                // sub_qyxx_data.license_url = e.target.result
                ht_list2.push({
                    name: _file.name,
                    result: res.data // e.target.result
                })
                set_ht_list(ht_list2, '.ht-list2')
                if(ht_list2.length){
                    $('.j-ht-up-sub').show()
                }
            }
        }
    })
    // var reader = new FileReader();
    // reader.readAsDataURL(_file);
    // reader.onload = function (e) {
    //     ht_list2.push({
    //         name: _file.name,
    //         result: e.target.result
    //     })
    //     set_ht_list(ht_list2, '.ht-list2')
    //     if(ht_list2.length){
    //         $('.j-ht-up-sub').show()
    //     }
        
    // };
})

$('.ht-list2').on('click','.del',function(){
    var index = $(this).attr('data-index')
    ht_list2.splice(index,1)
    set_ht_list(ht_list2, '.ht-list2')
    if(ht_list2.length){
        $('.j-ht-up-sub').show()
    }else{
        $('.j-ht-up-sub').hide()
    }
})
$('.j-ht-up-sub').on('click',function(){
    var list = set_contract_url(ht_list2)
    sub_ht_up(list)
})

function sub_ht_up(list){
    $.ajax({
        type: "POST",
        url: _api+"/company_order/upload",
        headers: {Authorization: user_token},
        data: JSON.stringify({
            file_path: list
        }),
        dataType: "json",
        success: function (res) {
            // toast({ msg: res.msg })
            if (res.status == 200) {
                get_company()

            }else{

            }
        }
    });
}
// 申请发票
var invoice_data = {} // 发票信息
$('.j-invoice-get').on('click', function(){
    $('#j-invoice-dialog .d-title').text('申请发票')
    $('#j-invoice-dialog .invoice-radio').removeClass('disabled')
    $('#sub_apply_invoice').removeClass('is-edit')
    $('#j-invoice-dialog').fadeIn()
})
$('.j-invoice-edit').on('click', function(){
    var _invoice = $('#j-invoice-dialog')
    _invoice.find('.d-title').text('修改发票')
    // _invoice.find('.invoice-radio').removeClass('checked').addClass('disabled')
    // console.log(invoice_data.invoice_type)
    _invoice.find('.invoice-radio[value="'+invoice_data.invoiceType+'"]').addClass('checked')

    _invoice.find('[name=company_invoice_title]').val(invoice_data.invoiceTitle)
    _invoice.find('[name=company_invoice_tax_number]').val(invoice_data.taxCode)
    _invoice.find('[name=mailing_email]').val(invoice_data.email)
    _invoice.find('[name=mailing_username]').val(invoice_data.contact)
    _invoice.find('[name=mailing_phone]').val(invoice_data.mobilePhone)
    _invoice.find('[name=invoicePrice]').val(invoice_data.invoicePrice)
    // _invoice.find('[name=id]').val(invoice_data.id)
    // _invoice.find('[name=company_invoice_phone]').val(invoice_data.company_invoice_phone)
    
    // _invoice.find('[name=mailing_username]').val(invoice_data.mailing_username)
    // _invoice.find('[name=mailing_phone]').val(invoice_data.mailing_phone)
    // _invoice.find('[name=mailing_email]').val(invoice_data.mailing_email)

    // let address = invoice_data.mailing_address.split('/')
    // let mailing_address = ''
    // for (let index = 3; index < address.length; index++) {
    //     mailing_address+= address[index];
    // }

    // _invoice.find('[name=mailing_address]').val(mailing_address)
    // _invoice.find('[name=province]').val(address[0]).trigger('change')
    // _invoice.find('[name=city]').val(address[1]).trigger('change')
    // _invoice.find('[name=district]').val(address[2]).trigger('change')
    // console.log(invoice_data)
    // if(invoice_data.company_invoice_type == '2'){
    //     $('.invoice-type-1').hide()
    //     $('.invoice-type-2').show()
    // }else{
    //     $('.invoice-type-1').show()
    //     $('.invoice-type-2').hide()
    // }

    $('#sub_apply_invoice').addClass('is-edit')
    $('#j-invoice-dialog').fadeIn()
})
$('.j-invoice-edit2').on('click', function(){
    var _invoice = $('#j-invoice-dialog')
    _invoice.find('.d-title').text('重新申请发票')
    // console.log(invoice_data.invoice_type)
    _invoice.find('.invoice-radio[value="'+invoice_data.invoiceType+'"]').addClass('checked')
    if(invoice_data.invoiceType ==1){
        console.log("1111");
        
        _invoice.find('.invoice-radio[value="'+2+'"]').removeClass('checked')
    }else{
        console.log("222");
        _invoice.find('.invoice-radio[value="'+1+'"]').removeClass('checked')
    }
    

    _invoice.find('[name=company_invoice_title]').val(invoice_data.invoiceTitle)
    _invoice.find('[name=company_invoice_tax_number]').val(invoice_data.taxCode)
    _invoice.find('[name=mailing_email]').val(invoice_data.email)
    _invoice.find('[name=mailing_username]').val(invoice_data.contact)
    _invoice.find('[name=mailing_phone]').val(invoice_data.mobilePhone)
    _invoice.find('[name=invoicePrice]').val(invoice_data.invoicePrice)
    $('#j-invoice-dialog').fadeIn()
})
// 选择发票类型
// $('.invoice-type-1').show()
// $('.invoice-type-2').hide()
$('.invoice-radio').on('click', function () {
    var _this = $(this)
    if(_this.hasClass('disabled')){
        return
    }
    $('.invoice-radio').removeClass('checked')
    _this.addClass('checked')

    let invoice_type = _this.attr('value')
    // if(invoice_type == '2'){
    //     $('.invoice-type-1').hide()
    //     $('.invoice-type-2').show()
    // }else{
    //     $('.invoice-type-1').show()
    //     $('.invoice-type-2').hide()
    // }
})

$('#sub_apply_invoice').on('click', function(){
    var data = getFormData('#form-invoice')
    data.company_invoice_type = parseInt($('.invoice-radio.checked').attr('value'))
    console.log("我是申请发票",data);
    
    // // data.user_token = user_token
    data.company_invoice_type = parseInt($('.invoice-radio.checked').attr('value'))
    if(
        !data.company_invoice_type ||
        !data.mailing_email ||
        !data.mailing_phone ||
        !data.mailing_username ){
    
        toast({ msg: '请填写完整信息' })
        return false
    }else{
        if(!check_email(data.mailing_email)){
            toast({ msg: '电子邮箱格式不正确' })
            return false
        }
        if(!check_phone(data.mailing_phone)){
            toast({ msg: '联系电话格式不正确' })
            return false
        }
    }
    data.invoiceTitle = data.company_invoice_title
    data.taxCode = data.company_invoice_tax_number
     data.invoiceType = data.company_invoice_type
     data.contact = data.mailing_username
     data.mobilePhone = data.mailing_phone
     data.email = data.mailing_email
    
    // console.log(data)
    // if(data.company_invoice_type == 2){
    //     if(
    //         !data.company_invoice_bank ||
    //         !data.company_invoice_bank_account ||
    //         !data.company_invoice_address ||
    //         !data.company_invoice_phone ){
        
    //         toast({ msg: '请填写完整信息' })
    //         return false
    //     }
        
    //     if(!data.mailing_email){
    //         toast({ msg: '请填写电子邮箱' })
    //         return
    //     }else{
    //         if(!check_email(data.mailing_email)){
    //             toast({ msg: '电子邮箱格式不正确' })
    
    //             return 
    //         }
    //     }
    // //     if(!check_tel(data.company_invoice_phone)){
    // //         toast({ msg: '开票信息：注册电话格式不正确' })

    // //         return false
    // //     }
    // //     if(!check_tel(data.mailing_phone)){
    // //         toast({ msg: '邮寄信息：联系电话格式不正确' })

    // //         return false
    // //     }
    // //     data.mailing_address = data.province+'/'+data.city+'/'+data.district+'/'+data.mailing_address
    // //     delete data.mailing_email
    // }else{
    //     if(data.company_invoice_phone){
    //         if(!check_tel(data.company_invoice_phone)){
    //             toast({ msg: '开票信息：注册电话格式不正确' })
    
    //             return 
    //         }
    //     }
    //     if(!data.mailing_email){
    //         toast({ msg: '请填写电子邮箱' })
    //         return
    //     }else{
    //         if(!check_email(data.mailing_email)){
    //             toast({ msg: '电子邮箱格式不正确' })
    
    //             return 
    //         }
    //     }
    // }
    // console.log(data)
    if($(this).hasClass('is-edit')){
        // data.id = invoice_data.order_id
        // delete data.company_invoice_type
        data.id = invoice_data.id
        apply_invoice(data, '/web/v1/order/invoice/edit')
    }else{
        apply_invoice(data, '/web/v1/order/invoice/add')
    }
})

function apply_invoice(data, url){
    // console.log(data)
    $.ajax({
        type: "post",
        url: _api+url,
        headers: {Authorization: user_token},
        data: data,
        dataType: "json",
        success: function (res) {
            // toast({ msg: res.msg })
            if (res.code == 0) {
                // toast({ msg: res.msg })
                $('#j-invoice-dialog').fadeOut()
                get_company()
                // get_invoice()
            }
            // else if(res.status == 500){
            //     let err = JSON.parse(res.data.err)
            //     toast({ msg: err.describe})
            // }
            else{
                
                toast({ msg: typeof(res.msg) == 'string'? res.msg : (res.msg || '发票申请失败')})
            }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            console.log(1,XMLHttpRequest)
        }
    }).done(function(res){
        // console.log(2,res)
    }).fail(function(res){
        console.log(3,res)
    }).always(function(res){
        // console.log(4,res)
    });
}

// 获取发票
function get_invoice(){
    $('.j-invoice-status').hide()
    $('.j-invoice-status2').hide()
    $('.j-invoice-status3').hide()
    $('.j-invoice-status4').hide()
    $('.j-invoice-get').hide()
    $('.j-invoice-detail').hide()
    $('.j-invoice-down').hide()
    $('.j-invoice-edit').hide()
    $('.j-invoice-edit2').hide()
    if(company_info.invoice.length == 0){
        $('.j-invoice-get').show()
        $('.noSq').show()
        $('.yesSq').hide()
    }else{
        if(company_info.invoice.status == 0){
            $('.j-invoice-status').show()
            $('.j-invoice-detail').show()
            $('.j-invoice-edit').show()
        }else if(company_info.invoice.status == 1){
            $('.j-invoice-status4').show()
            $('.j-invoice-down').show()
            $('.j-invoice-detail').show()
        }else if(company_info.invoice.status == 2){
            $('.j-invoice-status2').show()
            $('.j-invoice-detail').show()
            $('.j-invoice-edit2').show()
        }else if(company_info.invoice.status == 3){
            $('.j-invoice-status3').show()
            $('.j-invoice-detail').show()
            $('.j-invoice-edit').show()
        }
        $('.noSq').hide()
        $('.yesSq').show()
        
        set_invoice_detail(company_info.invoice)
        invoice_data = company_info.invoice
        
        // $.ajax({
        //     type: "get",
        //     url: _api+"/company_invoice/get_invoice/"+company_info.order_id,
        //     headers: {Authorization: user_token},
        //     // data: {
        //     //     id: company_info.order_id
        //     // },
        //     dataType: "json",
        //     success: function (res) {
        //         if (res.status == 200) {
        //             $('.j-invoice-detail').show()
                    
        //             var data = res.data
        //             invoice_data = data
        //             $('.j-invoice-status').show().html({'0':'已删除', '1':'开票中', '2':'已开票', '3':'已冲红'}[data.company_invoice_status])
        //             if(data.company_invoice_type == '1'){
        //                 if(data.company_invoice_status == '2'){
        //                     $('.j-invoice-down').show().attr('href', data.company_invoice_file)
        //                 }
        //             }else{
        //                 // $('.j-invoice-down').hide()
        //                 if(data.company_invoice_status == '1'){
        //                     $('.j-invoice-edit').show()
        //                 }
        //             }
        //             set_invoice_detail(data)

        //         }else{

        //         }
        //     }
        // });
    }
}

// 发票详情
$('.j-invoice-detail').on('click',function(){
    $('#j-invoice-detail-dialog').fadeIn()
})
$('.j-invoice-down').on('click',function(){
    window.location.href = sessionStorage.getItem('invoiceUrl')
})

function set_invoice_detail(d){
    // d.company_invoice_type = '1'
    // d.company_invoice_status = '2'
    var _detail = $('#invoice-detail')
    if(d.status == '1'){
        _detail.find('.status-bar').addClass('status2')
        _detail.find('.isBtnShow').show()
    }else if(d.status == '2'){
        _detail.find('.status-bar').addClass('status2')
        _detail.find('.isBtnShow').hide()
        $('.textCon').html('已冲红')
        $('.hideLine').hide()
        $('.hideIcon').hide()
    }else if(d.status == '3'){
        _detail.find('.isBtnShow').hide()
        $('.textCon').html('已驳回')
    }else{
        _detail.find('.status-bar').removeClass('status2')
        _detail.find('.isBtnShow').hide()
        $('.hideLine').show()
        $('.hideIcon').show()
        $('.textCon').html('开票中')
    }
    _detail.find('.before_price').html(d.company_invoice_money)
    _detail.find('.invoice_type').html(d.invoiceType == '1'?'电子普票':'电子专票')
    _detail.find('.company_invoice_title').html(d.invoiceTitle)
    _detail.find('.company_invoice_tax_number').html(d.taxCode)
    _detail.find('.create_time').html(d.time)
    _detail.find('.invoicePrice').html(d.invoicePrice)
    
    // if(d.company_invoice_type == '1'){
    //     $('.j-type-2').hide()
    //     $('.j-type-1').show()
        
        _detail.find('.mailing_email').html(d.email)
    // }else{
    //     $('.j-type-2').show()
    //     $('.j-type-1').hide()
        _detail.find('.company_invoice_contact').html(d.contact)
        _detail.find('.company_invoice_phone').html(d.mobilePhone)
        // _detail.find('.mailing_address').html(d.mailing_address)
        // _detail.find('.mailing_username').html(d.mailing_username)
        // _detail.find('.mailing_phone').html(d.mailing_phone)
    // }
    if(d.status == '1'){
        sessionStorage.setItem('invoiceUrl',d.invoiceUrl)
    }

}

// 续存
$('#btn-xf').on('click',function(){
    $('.isvipxf').html('VIP会员续费')

    $('#box-status-4').show().siblings().hide();
    $('.pay_status_all_1').hide()
    $('.pay_status_all_0').show()

    $('#j-pay-dialog').fadeIn()
    $.ajax({
            type: "post",
            url: _api+"/web/v1/user/member/extendMember",
            headers: {Authorization: user_token},
            dataType: "json",
            success: function (res) {
            }
        });
    change_pay_type()
    get_company()
    // company_info.status = '3'
    // set_company_status()

    // $('.xc-off').hide()
    // $('.tab-status-2').text('选择续存方式')
    // $('.tab-status-3').text('续存审核')
    // $('.tab-status-4').text('会员续存成功')
    // $('#sqjr').text('会员续存')
    // $('#j-xf').hide()
})


// 锚点
$('#j-nav-10').on('click', 'a', function () {
    $(this).addClass('active').siblings('a').removeClass('active')
})

// function maodian(){
    // var h1 = $( "#jrwm" ).offset().top + 80;
    console.log("iopipo",$( "#jrfs" ).offset());
    if($( "#jrfs" ).offset()){

    var h2 = $( "#jrfs" ).offset().top + 80;
    var h3 = $( "#sqjr" ).offset().top + 80;
    var h4 = $( "#lxwm" ).offset().top + 80;
    }
    
    
    
// }
var md_timer = null
$(document).scroll(function() {
    var scroH = $(document).scrollTop();  //滚动高度
    var viewH = $(window).height();  //可见高度
    var contentH = $(document).height();  //内容高度

    if(md_timer){
        clearTimeout(md_timer)
    }
    md_timer = setTimeout(function(){
        if(scroH > h4){  //距离顶部大于100px时
            $('.lxwm').addClass('active').siblings('.md').removeClass('active')
            
        }else if(scroH > h3){
            $('.sqjr').addClass('active').siblings('.md').removeClass('active')
        }else if(scroH > h2){
            $('.jrfs').addClass('active').siblings('.md').removeClass('active')
        }else{
            $('.jrwm').addClass('active').siblings('.md').removeClass('active')
        }
    }, 600)
});

// logo
var logo_left = 0
var n_left = 0

var box_w = $('#logo-list-box').width()
var w = $('.logo1').width()

var n0 = $('#logo-list>div').length
var n1 = $('.logo1').length
var n2 = $('.logo2').length

$('#logo-list').append($('#logo-list').html())
$('#logo-list').width(n0 * 2 * w)
console.log("78879",$('#logo-list'));

var logo_timer = setInterval(logo_play, 2000);

function logo_play(){
    n_left++
    if(n_left == n0+1){
        $('#logo-list').animate({'marginLeft': 0}, 0)
        n_left = 1
    }
    logo_left = n_left*-w
    $('#logo-list').animate({'marginLeft': logo_left}, 2000, 'linear')

    if(logo_left-box_w < n0*-w){
        $('#logo-tab>li').eq(0).addClass('active').siblings('li').removeClass('active')
    }else if(logo_left-box_w < (n1+n2)*-w){
        $('#logo-tab>li').eq(2).addClass('active').siblings('li').removeClass('active')
    }else if(logo_left-box_w < n1*-w){
        $('#logo-tab>li').eq(1).addClass('active').siblings('li').removeClass('active')
    }else{
        $('#logo-tab>li').eq(0).addClass('active').siblings('li').removeClass('active')
    }
}

$('#logo-tab').on('click','li',function(){
    var _index = $(this).index()
    $(this).addClass('active').siblings('li').removeClass('active')
    if(_index == 1){
        n_left = n1
    }else if(_index == 2){
        n_left = n1+n2
    }else{
        n_left = 0
    }
    logo_left = n_left*-w
    $('#logo-list').stop()
    clearInterval(logo_timer)
    $('#logo-list').animate({'marginLeft': logo_left}, 0)
    // logo_play()
    logo_timer = setInterval(logo_play, 2000);
})

function _get_code(btn, phone, rul){
    var _time = 60;
    $(btn).on('click',function(){
        // var _this = $(this)
        if($(this).hasClass('is-off')){

        }else{
            var _phone = $(phone).val()
            
            if(_phone){
                if(!check_phone(_phone)){
                    toast({ msg: '请输入正确的手机号' })
                }else{
                    _time = 60
                    set_time()
                    get_code(_phone)
                }
            }
        }
    })

    function get_code(phone){
        $.ajax({
            type: "POST",
            url: _api+'/web/v1/auth/sendSms',
            data:{mobilePhone: phone},
            headers: {Authorization: user_token|| ''},
            dataType: "json",
            success: function (res) {
                if(res.code == 0){
                    toast({msg: '获取验证码成功'})
                }else{
                    // _time = 0
                    toast({msg:  res.msg})
                }
            }
        });
    }
    function set_time(){
        if( _time<= 0){
            $(btn).removeClass('is-off').html('获取验证码')
        }else{
            $(btn).addClass('is-off').html('('+_time+')')
            setTimeout(function() {
                _time--
                set_time()
            }, 1000)
        }
    }
}
    },
    methods:{
        downFp(){
            window.location.href = sessionStorage.getItem('invoiceUrl')
        }
    }
}
function toast(n) {
    var t = document;
    var toastId = document.getElementById('toastId');
    if(toastId){
        toastId.remove();
        // toastId.parentNode.removeChild(toastId);
    }
    
    var e = t.createElement("div")
    e.id = 'toastId';
    e.innerHTML = n.msg 
    
    t.body.appendChild(e);
    var r = setTimeout(function() {
        clearTimeout(r)
        e.remove();
        // t.body.removeChild(e)
    }, n.time || 2e3)
    
}
// 手机
function check_phone(phone){
    // return phone.match(/^1[3-9]\d{9}$/)
    var re = new RegExp(/^1[3-9]\d{9}$/)
    // console.log(tel, re.test(tel))
    return re.test(phone)
}
// 获取form表单数据
function getFormData(formId){
    var data = {};
    var results = $(formId).serializeArray();
    $.each(results,function(index,item){
        //文本表单的值不为空才处理
        if(item.value && $.trim(item.value)!=""){
            if(!data[item.name]){
                data[item.name]=item.value;
            }else{
                //name属性相同的表单，值以英文,拼接
                data[item.name]=data[item.name]+','+item.value;
            }
        }
    });
    //console.log(data);
    return data;
}
function check_email(email){
    var re = new RegExp(/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/)
    return re.test(email)
}





// WEBPACK FOOTER //
// ./src/js/activity.js